import { ThemeUIStyleObject } from "theme-ui";

export const resetPrevNextButton: ThemeUIStyleObject = {
  ".swiper-button-prev, .swiper-button-next": {
    background: "none",
    outline: "none",
    width: "auto",
    height: "auto",
    top: "50%",
    transform: "translate3d(0, -50%, 0)",
    marginTop: 0,
    borderRadius: "50%",
    border: "1px solid rgba(0,0,0, 0)",
    p: 0,
    "&:hover, &:focus": {
      boxShadow: "none",
      "svg circle": {
        opacity: 0.5,
      },
    },
  },
  ".swiper-button-prev": {
    left: 7,
  },
  ".swiper-button-next": {
    right: 7,
  },
  ".swiper-button-prev:after, .swiper-button-next:after": {
    content: "none",
  },
};

export const mediaSliderContainerStyle: ThemeUIStyleObject = {
  position: "relative",
  width: "100%",
  mx: "auto",
  px: 4,
  zIndex: "dropdown",
  ":after": {
    display: "block",
    content: "''",
    width: "80%",
    height: "200px",
    boxShadow: "floatingXl",
    borderRadius: "full",
    position: "absolute",
    bottom: "52px",
    left: "50%",
    transform: "translate3d(-50%, 0, 0)",
  },
};

const arrowBaseStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate3d(-50%, -50%, 0)",
  height: "16px",
};

export const leftArrowSpanStyles: ThemeUIStyleObject = {
  ...arrowBaseStyles,
};
export const rightArrowSpanStyles: ThemeUIStyleObject = {
  ...arrowBaseStyles,
};

export const leftArrowStyles: ThemeUIStyleObject = {
  transform: "rotate(180deg)",
};

export const rightArrowStyles: ThemeUIStyleObject = {};

export const ellipseStyles: ThemeUIStyleObject = {
  width: "44px",
  height: "44px",
  "> svg": {
    width: "full",
    height: "full",
  },
};

export const swiperStyles: ThemeUIStyleObject = {
  ...resetPrevNextButton,
  ".swiper-pagination": {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "52px",
    ml: 6,
    mr: 6,
    width: "auto",
  },
  ".swiper-pagination-bullet": {
    position: "relative",
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "transparent",
    bg: "transparent",
    margin: "0 10px",
    opacity: 1,
    ":before": {
      content: "''",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate3d(-50%, -50%, 0)",
      bg: "darkGreen",
      width: "5px",
      height: "5px",
      borderRadius: "50%",
    },
    ":hover, :focus": {
      borderColor: "darkGreen",
      ":before": {
        bg: "darkGreen",
      },
    },
  },
  ".swiper-pagination-bullet-active": {
    borderColor: "darkGreen",
    ":before": {
      bg: "darkGreen",
    },
  },

  ".swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled":
    {
      opacity: 0.5,
    },
};
